import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { App } from "./App";
import { PostHogProvider } from "posthog-js/react";

ReactDOM.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey="phc_hcvjmgJa6ZuOpsRzx18nEiPuavncFTCN9jNNQVNgVcH"
      options={{
        api_host: "https://us.i.posthog.com",
        defaults: "2026-01-30",
        capture_exceptions: true,
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PostHogProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

